import React from 'react'

import { Form, Col } from '_zari/core'

const CorrelativoFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='CORRELATIVO' htmlFor='input-correlativo' md={4} alignRightAt='md' />
      <Col md={8}>
        <Form.InputText id='input-correlativo' name='input-correlativo' disabled defaultValue={iValue} />
      </Col>
    </Form.Group>
  )
}

export default React.memo(CorrelativoFormGroup)
